import React from 'react';
import styles from './Wrapper.module.scss';

export const Wrapper = ({ children }) => (
  <div className={styles.wrapper}>{children}</div>
);
